export default {
      id: "checked-usage",
      viewBox: "0 0 64 54",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#checked-usage",
      toString: function () {
        return this.url;
      }
    }